import {BASE_URL, http} from './axios';
import {LoginInfo, LoginInfoUpsertRequest} from '../models/navigationInfo/login-info.interface';
import {CustomResponse} from '../models/shared/custom-response';

export const upsertLoginInfo = (loginInfoUpsertRequest: LoginInfoUpsertRequest): Promise<CustomResponse<LoginInfo>> => {
  return http.post(`${BASE_URL}/navigation-info/login-info/upsert`, loginInfoUpsertRequest, {
    isBackground: true,
  } as any);
};
